/**
 * Application Configuration
 */

export const APP_CONFIG = {
  // Enable/Disable X-ray service type
  ENABLE_XRAY: false, // Set to true to enable X-ray booking, false to use only US (Ultrasound)
  
  // Clinic Information
  CLINIC_NAME: 'Mona-Medical',
  DEFAULT_CREATED_BY: 'Admin', // Fallback if no user name is provided
} as const;
